import React, { useState, useEffect } from 'react';
import { Form, Input, InputNumber, Select, message } from 'antd';
import Service from '../../../../../Service';

const { Option } = Select;

const AddEditExpense = ({ expense, onSuccess }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);
    const [categoriesLoading, setCategoriesLoading] = useState(false);

    useEffect(() => {
        fetchCategories();
    }, []);

    useEffect(() => {
        if (expense) {
            form.setFieldsValue({
                desc: expense.desc,
                amount: expense.amount,
                category: expense.category,
            });
        } else {
            form.resetFields();
        }
    }, [expense, form]);

    const fetchCategories = async () => {
        setCategoriesLoading(true);
        try {
            const service = new Service();
            const response = await service.ExpenseService.getExpenseCategories();
            setCategories(response);
        } catch (error) {
            message.error('Kategoriler yüklenirken hata oluştu');
        } finally {
            setCategoriesLoading(false);
        }
    };

    const handleSubmit = async (values) => {
        setLoading(true);
        try {
            const service = new Service();
            if (expense) {
                await service.ExpenseService.updateExpense(expense.id, values);
                message.success('Harcama başarıyla güncellendi');
            } else {
                await service.ExpenseService.createExpense(values);
                message.success('Harcama başarıyla eklendi');
            }
            form.resetFields();
            onSuccess();
        } catch (error) {
            message.error(expense ? 'Harcama güncellenirken hata oluştu' : 'Harcama eklenirken hata oluştu');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            initialValues={{
                desc: '',
                amount: 0,
                category: '',
            }}
        >
            <Form.Item
                label="Açıklama"
                name="desc"
                rules={[
                    { required: true, message: 'Açıklama alanı zorunludur' },
                    { min: 3, message: 'Açıklama en az 3 karakter olmalıdır' },
                ]}
            >
                <Input placeholder="Harcama açıklaması giriniz" />
            </Form.Item>

            <Form.Item
                label="Tutar"
                name="amount"
                rules={[
                    { required: true, message: 'Tutar alanı zorunludur' },
                    { type: 'number', min: 0.01, message: 'Tutar 0\'dan büyük olmalıdır' },
                ]}
            >
                <InputNumber
                    placeholder="Tutar giriniz"
                    style={{ width: '100%' }}
                    min={0}
                    step={0.01}
                    formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                />
            </Form.Item>

            <Form.Item
                label="Kategori"
                name="category"
                rules={[
                    { required: true, message: 'Kategori seçimi zorunludur' },
                ]}
            >
                <Select
                    placeholder="Kategori seçiniz"
                    loading={categoriesLoading}
                    showSearch
                    filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                >
                    {categories.map((category) => (
                        <Option key={category.id} value={category.name}>
                            {category.name}
                        </Option>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item>
                <div className="flex justify-end space-x-2">
                    <button
                        className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
                        onClick={() => {
                            form.resetFields();
                            onSuccess();
                        }}
                    >
                        İptal
                    </button>
                    <button
                        className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? 'İşleniyor...' : (expense ? 'Güncelle' : 'Kaydet')}
                    </button>
                </div>
            </Form.Item>
        </Form>
    );
};

export default AddEditExpense; 